<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>{{user.name}} {{user.lastname}}</template>
        <template v-slot:content>
            <div class='py-3'>Удалить пользователя?</div>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 red--text text--darken-2' :loading = 'indicator' block depressed @click = 'deletePerson'>Удалить</v-btn>
        </template>
    </dialog-generic>
</template>
<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'UserDelete',
        props: ['data', 'postAction', 'initialState'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visibility: this.initialState,
                indicator: false,
                user: this.data
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value;
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
            data(value) {
                this.user = value
            }
        },
        methods: {
            deletePerson() {
                this.indicator = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                this.$http.patch(this.$store.getters.endpoint + '/db/persons', {
                    ...{ 'login': this.$store.getters.userLogin, 'user': this.user }
                }, {
                    headers: { ...this.$store.state.restrictedHeaders,
                        ...requestHeaders
                    }
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.indicator = false
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'delete',
                                target: 'user'
                            },
                            once: false
                        })
                        this.postAction();
                        this.visibility = false;
                    } else {
                        console.log(response)
                    }
                })
            }
        }
    }
</script>